import "./bootstrap";
import "../css/main.css";

import { createApp, h } from "vue";
import { createInertiaApp, usePage } from "@inertiajs/vue3";
import { setUrlDefaults } from "./wayfinder";
import { createVfm } from "vue-final-modal";
import Layout from "./Layouts/Layout.vue";
import InputButton from "./Components/Inputs/Button.vue";
import OpenVoteAlert from "./Components/Vote/OpenVoteAlert.vue";

const appName = import.meta.env.VITE_APP_NAME || "EGP Congress";
const vfm = createVfm();

// Every edition-scoped Wayfinder route takes its {edition} slug from the shared Inertia prop
setUrlDefaults(() => ({ edition: usePage().props.edition?.slug }));
const pageElement = document.querySelector('script[data-page="app"]');

if (!pageElement?.textContent) {
    throw new Error(
        "Missing Inertia page payload. Confirm the response is rendered with the @inertia directive and is not being replaced or cached by the server.",
    );
}

createInertiaApp({
    page: JSON.parse(pageElement.textContent),
    title: (title) => (title ? `${title} - ${appName}` : appName),
    resolve: async (name) => {
        const pages = import.meta.glob("./Pages/**/*.vue");
        const page = await pages[`./Pages/${name}.vue`]();
        page.default.layout = page.default.layout || Layout;
        return page;
    },
    setup({ el, App, props, plugin }) {
        // OpenVoteAlert sits outside the page so it persists across navigation
        createApp({ render: () => [h(App, props), h(OpenVoteAlert)] })
            .use(plugin)
            .use(vfm)
            .component("InputButton", InputButton)
            .mount(el);
    },
    progress: {
        color: "#FFDC2E",
    },
});
